import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL, ADMIN_API_PREFIX } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { AppSettings, appSettingsApi } from '../api/app-settings.api';

type UpdateAppSettingsParams = Partial<AppSettings> & {
    header_logo_image?: File;
};

export const appSettingsAdminApi = createApi({
    reducerPath: 'app-settings-admin-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + ADMIN_API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: ['AppSettings'],
    endpoints: (builder) => ({
        updateAppSettings: builder.mutation<AppSettings, UpdateAppSettingsParams>({
            query: (params) => {
                const formData = new FormData();

                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        // Check if value is a File object by checking for File-specific properties
                        if (typeof value === 'object' && 'name' in value && 'size' in value && 'type' in value) {
                            formData.append(key, value as File);
                        } else {
                            formData.append(key, value.toString());
                        }
                    }
                });

                return {
                    url: '/app-settings/',
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: ['AppSettings'],
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    
                    // Invalidate the regular app settings API cache to ensure the header logo updates
                    dispatch(appSettingsApi.util.invalidateTags(['AppSettings']));
                } catch (e) {
                    // Handle error silently
                }
            },
        }),
    }),
});

export const {
    useUpdateAppSettingsMutation,
} = appSettingsAdminApi;
